import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useT } from "@/context/LangContext";
import { SECTORS } from "@/constants/sectors";

export default function Sectors() {
  const t = useT();
  return (
    <div data-testid="sectors-page">
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-8">
        <p className="kicker">{t("sectors.kicker")}</p>
        <h1 className="text-5xl lg:text-7xl font-display font-black tracking-tighter mt-4 max-w-4xl">
          {t("sectors.title")}
        </h1>
        <p className="text-[var(--ink-soft)] mt-6 max-w-2xl text-lg">{t("sectors.desc")}</p>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-12 grid grid-cols-1 md:grid-cols-2 gap-8">
        {SECTORS.map((s) => {
          const Icon = s.icon;
          return (
            <Link
              key={s.slug}
              to={`/secteurs/${s.slug}`}
              className="group relative block overflow-hidden rounded-lg aspect-[4/5] md:aspect-[5/6]"
              data-testid={`sector-card-${s.slug}`}
            >
              <img
                src={s.hero}
                alt={t(`sector.${s.slug}.t`)}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
              <div className="absolute inset-0 p-8 flex flex-col justify-end text-white">
                <Icon size={26} style={{ color: s.accent }} />
                <h2 className="font-display text-3xl lg:text-4xl font-black mt-4 max-w-md">
                  {t(`sector.${s.slug}.t`)}
                </h2>
                <p className="text-white/70 mt-3 max-w-md">{t(`sector.${s.slug}.d`)}</p>
                <span className="mt-6 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-widest text-[var(--accent)] group-hover:gap-4 transition-all">
                  {t("home.sectors.discover")} <ArrowRight size={16} />
                </span>
              </div>
            </Link>
          );
        })}
      </section>
    </div>
  );
}
